export default function Cart(){
    return (
      <h1>No Items Present in the Cart</h1>
    )
}